// extracted by mini-css-extract-plugin
export default {"wrapper":"MpasiList_wrapper__W35sq","font-title":"MpasiList_font-title__xvP0k"};